import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, IconButton, Typography } from '@mui/material';

import { FLAGS_BASE_URL } from '@/constants';

interface DepositHeaderProps {
  balance: number;
  onClose: () => void;
  onBack?: () => void;
  title?: string;
  country?: string;
  onShowCountryList?: () => void;
}

export const DepositHeader = ({
  onClose,
  onBack,
  title = 'Buy crypto',
  country,
  onShowCountryList,
}: DepositHeaderProps) => {
  return (
    <Box className="mb-8 flex items-center justify-between gap-4">
      <Box className="flex items-center gap-2">
        {onBack ? (
          <IconButton
            onClick={onBack}
            className="-ml-2 h-10 w-10 text-[var(--text-primary)] opacity-60 hover:opacity-100"
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
          </IconButton>
        ) : (
          <Box className="flex items-center gap-0.5">
            <Box
              component="svg"
              width={22}
              height={22}
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Porvenix logo icon"
              sx={{
                color: 'text.primary',
                flexShrink: 0,
              }}
            >
              <circle
                cx="16"
                cy="16"
                r="14"
                stroke="currentColor"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="4"
                y1="16"
                x2="28"
                y2="16"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </Box>
          </Box>
        )}

        <Typography
          className="text-base font-bold text-[var(--text-primary)]"
          sx={{
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box className="flex items-center gap-2">
        {onShowCountryList && (
          <Box className="flex shrink-0 items-center gap-2">
            <button
              onClick={onShowCountryList}
              className="flex items-center gap-1 rounded-xl px-2 py-1.5 text-xs font-bold text-[var(--text-primary)] transition-all hover:bg-white/5"
            >
              <Box
                component="img"
                src={country ? `${FLAGS_BASE_URL}/${country.toLowerCase()}.svg` : ''}
                className="h-4 w-4 object-cover"
                onError={(e: any) => (e.target.style.display = 'none')}
              />
              {country}
              <KeyboardArrowDownIcon sx={{ fontSize: 14, color: 'var(--text-muted)' }} />
            </button>
          </Box>
        )}

        <IconButton
          onClick={onClose}
          className="-mr-2 h-10 w-10 text-[var(--text-primary)] opacity-60 hover:opacity-100"
        >
          <CloseIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>
    </Box>
  );
};
